export default __webpack_public_path__ + "static/media/regular.191ce7a6.png";